import React, { useEffect, useState } from "react";
import * as ReworkProductService from "../../../../services/reworkProductServices";
import * as ItemService from "../../../../services/ItemService";
import PaginateList from "../../../utils/PaginateList";
import { ORDER_TYPE, TYPE_PART } from "../../../../constants/index";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  ButtonAction,
  Icon,
  Option,
  ListOptions,
} from "./reworkProductList.styled";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";

import { getDateFormatTimeZone } from "../../../../utils/formats";

const ReworkProductListContainer = ({ filters }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);

  const refresh = () => {
    setForceRefresh(true);
  };

  const [varieties, setVarieties] = useState([]);

  useEffect(() => {
    const loadVarieties = async () => {
      try {
        const variety = await ItemService.getVarietiesCascara();

        setVarieties(variety);
      } catch (error) {
        console.error(error);
      }
    };

    loadVarieties();
  }, []);

  const handlerOpenReworkProduct = () => {
    // setType(null);
    // setShowPoint(true);
    // setShowResume(false);
    // setAction("open");
  };
  const columns = [
    {
      header: t("forms.reworkProduct.table.head.dateInit"),
      accessorKey: "dateInit",
      cell: (info) =>
        info.getValue()
          ? getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm")
          : "-",
    },
    {
      header: t("forms.reworkProduct.table.head.dateEnd"),
      accessorKey: "dateEnd",
      cell: (info) =>
        info.getValue()
          ? getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm")
          : "-",
    },
    {
      header: t("forms.reworkProduct.table.head.entryPoint"),
      accessorKey: "inpoint.name",
      cell: (info) => t(info.getValue()) || "-",
    },
    {
      header: t("forms.reworkProduct.table.head.status"),
      accessorKey: "status",
      cell: (info) => info.getValue() || "-",
    },
    {
      header: t("forms.reworkProduct.table.head.outPoint"),
      accessorKey: "outputs",
      cell: (info) => {
        const outputs = info.getValue();

        return Array.isArray(outputs) && outputs.length > 0
          ? t(outputs.map((o) => t(o.name)).join(", "))
          : "-";
      },
    },
    {
      header: t("forms.reworkProduct.table.head.product"),
      accessorKey: "itemCodeProcessed",
      cell: (info) => {
        const itemCodeProcessed = info.getValue();

        const variety = varieties.find(
          (v) => v.varietyCode === itemCodeProcessed,
        );
        return variety?.variety || "-";
      },
    },
    {
      header: t("forms.reworkProduct.table.head.user"),
      accessorKey: "user.email",
      cell: (info) => info.getValue() || "-",
    },
    {
      header: t("forms.reworkProduct.table.head.actions"),
      accessorKey: "uuid",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  // const handlerClosePopup = (popupName) => {
  //   dispatch(hide(popupName));
  // };

  const goToDetail = (uuid) => {
    navigate(`/factory/reworkProduct/detail/${uuid}`);
  };

  const renderAction = (data) => {
    return (
      <>
        <div className="dropdown text-center">
          <button
            type="button"
            className="btn btn-secondary dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {t("forms.reworkProduct.table.head.actions")}
          </button>
          <ListOptions className="dropdown-menu dropdown-menu-lg-end">
            <Option>
              <ButtonAction
                onClick={() => goToDetail(data.uuid)}
                title={t("forms.reworkProduct.labels.detail")}
              >
                <Icon className="fa-solid fa-list"></Icon>
                {t("forms.reworkProduct.labels.detail")}
              </ButtonAction>
            </Option>
          </ListOptions>
        </div>
      </>
    );
  };

  const listData = async (filter) => {
    if (!filter.filters) {
      filter.filters = {
        type: TYPE_PART.code,
      };
    }
    const result = await ReworkProductService.listFilterReworkProducts(filter);
    return result;
  };

  const hiden = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    hiden.dateEnd = false;
    hiden.variety = false;
    hiden.origin = false;
    hiden.status = false;
    hiden.totalWeight = false;

    resize = false;
  } else if (deviceSize === SIZES.md) {
    hiden.variety = false;
    hiden.origin = false;
    hiden.location = false;
    resize = false;
  }

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hiden}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

export default ReworkProductListContainer;
